import { KnownConfigItemType, MultiEditCallbacks, MultiEditInsight } from '@ecosystem/newron-client-collections';
import { ConfigItemInfo } from '@ecosystem/newron-client-collections/build/public/MultiEditRegister/types';
import { ConfigItemType, ConfigValue } from '@ecosystem/newron-client-lib';
import { contextClient } from '../../client';
import { InsightData } from './types';
import { queryClient } from '../../page/ReactQueryProvider';

export const getCellsApplied = (insights: MultiEditInsight<InsightData>[]): Record<string, ConfigValue> => {
  return insights.reduce(
    (acc, insight) => {
      const configValues =
        insight?.data?.paramsForContext?.cell.map(item => {
          return { value: item.split('|')[0], label: item.split('|')[1] };
        }) || [];
      if (configValues.length > 0) {
        acc[insight.id] = configValues;
      }

      return acc;
    },
    {} as Record<string, ConfigValue>
  );
};

export const multiEditCallbacks: MultiEditCallbacks = {
  getAllowedTypes: () => [KnownConfigItemType.ProductGroup],
  getConfigItemInfo: async (configItemType, insights: MultiEditInsight<InsightData>[]) => {
    if (configItemType === KnownConfigItemType.ProductGroup) {
      const { data } = insights[0] || {};
      const { paramsForContext, corePageSettings } = data || {};

      const {
        context: { url: contextUrl },
      } = corePageSettings;

      const marketList = await queryClient.fetchQuery({
        queryKey: ['insight-context', `${contextUrl}/markets`],
        queryFn: () => {
          return contextClient.getContextSettingOptions(contextUrl + '/markets', paramsForContext);
        },
        staleTime: Infinity,
      });

      return {
        configItem: {
          key: 'context',
          label: 'Context',
          type: ConfigItemType.MultiCell,
          options: marketList,
        },
        configValues: getCellsApplied(insights),
      } as ConfigItemInfo;
    }
  },
};
